import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { Text } from 'components/text'

export const CardWrapper = styled(Link)`
  position: relative;
  overflow: hidden;
  color: ${props => props.theme.colors.primary.white} !important;
  display: block;

  padding-bottom: 139%;
  height: 0%;
  width: 100%;

  transition: 200ms ease;
  transition-property: transform;

  ${({ theme }) => theme.inViewStyle()}

  @media (hover: hover) {
    &:hover {
      transform: scale(1.025);
    }
  }
`

export const CardImage = styled.div`
  background: ${props => props.theme.colors.secondary.greylight};
  position: absolute;
  border-radius: 0.5rem;

  overflow: hidden;

  height: 100%;
  width: 100%;

  box-shadow: 0 0 0 rgba(0, 0, 0, 0.1);
  transition: 200ms ease;
  transition-property: box-shadow, transform;

  @media (hover: hover) {
    &:hover {
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
      transform: scale(1.025);
    }
  }
`

export const CardInner = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  padding: 20px;
  position: absolute;
`

export const Headline = styled(Text)`
  text-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
`
